/**
 * @file: 卧柜隔离
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree';
import * as UIToolkit from '../../UIToolkit';
import { updateCubeList } from '../../update/updateCubeList';
import { doneAsync } from '../../update/done';
import { updateCodiSystem } from '../../update/updateCodiSystem';
 
function close(): void {
    let cabinets: CubeId[] = CubeTree.findAllCabinet();
    let allCubes: CubeId[] = CubeTree.findAllInFreezerCubes();

    cabinets.forEach((curCabinet: CubeId): void => {
        UIToolkit.cabinetsLayout([curCabinet], 0);
    });

    updateCubeList(allCubes);
    updateCodiSystem();
    doneAsync();
}

export {
    close
};
